import { IS_DEVELOPMENT } from 'variables';
import createSagaMiddleware from 'redux-saga';
import { createStore, applyMiddleware, compose, Reducer } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { persistStore, persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import rootReducer from 'store/rootReducer';
import rootSaga from 'store/rootSaga';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
  }
}

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: [
    'app',
    'oauth',
    'usuarios',
    'practicas',
    'cursos',
    'informes',
    'photos',
  ],
};
const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const persistedReducer = persistReducer(
  persistConfig,
  rootReducer(history) as Reducer<any, any>
);
const composeEnhancers =
  (IS_DEVELOPMENT && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const enhancer = composeEnhancers(
  applyMiddleware(routerMiddleware(history), sagaMiddleware)
);
const store = createStore(persistedReducer, enhancer);
const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { store, persistor, history };
